"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeStep = exports.sanitizeScenario = exports.sanitizeActor = exports.sanitizeFeature = void 0;
var camelcase = require("lodash.camelcase");
var sanitizeName = function (name) {
    return camelcase(name.trim());
};
exports.sanitizeFeature = function (feature) {
    return __assign(__assign({}, feature), { name: sanitizeName(feature.name) });
};
exports.sanitizeActor = function (actor) {
    return __assign(__assign({}, actor), { name: sanitizeName(actor.name) });
};
exports.sanitizeScenario = function (scenario) {
    return __assign(__assign({}, scenario), { name: sanitizeName(scenario.name), steps: scenario.steps.map(exports.sanitizeStep) });
};
exports.sanitizeStep = function (step) {
    return __assign({}, step);
};
